var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Input, Output, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { Direction, ListService } from './list.service';
import { ItemBase } from '../../models/item/item-base';
var ListComponent = /** @class */ (function (_super) {
    __extends(ListComponent, _super);
    function ListComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.recs = [];
        _this.sort = {};
        _this.events = { sort: 'sort', row: 'row' };
        _this.sortable = true;
        _this.clickable = true;
        _this.bulkFlg = false;
        _this.bulkPrimaryKey = null;
        _this.bulkChecked = [];
        return _this;
    }
    ListComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        var params = this.component.params || {};
        this.groupName = this.service.getGroupName(params.groupName);
        this.saveQuery = this.service.setSaveQuery(this.groupName, params.saveQuery);
        this.sortable = this.action.validEvent(this.events.sort);
        this.clickable = this.action.validEvent(this.events.row);
        var orderByList = [];
        var cond = this.service.getCondition(this.groupName);
        if (typeof cond !== 'undefined' && this.saveQuery) {
            orderByList = cond.orderByList;
        }
        else {
            orderByList = (params.initQuery && params.initQuery.orderByList ? params.initQuery.orderByList : []);
        }
        this.service.getQuery({ orderByList: orderByList }, this.groupName);
        this.bulkFlg = false;
        this.bulkPrimaryKey = null;
        this.bulkSubsc = this.service.bulkObservable.subscribe(function (data) {
            if (typeof data !== 'undefined' && typeof data[_this.groupName] !== 'undefined') {
                _this.bulkFlg = true;
                _this.bulkPrimaryKey = _this.service.getBulkPrimaryKey(_this.groupName);
            }
        });
    };
    ListComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ListComponent.prototype.onSubscribe = function (data) {
        this.recs = [];
        this.sort = {};
        if (typeof data !== 'undefined') {
            this.recs = data.items;
            var query = this.service.getCurrentQuery(this.groupName);
            var orderByList = query.orderByList;
            var order = 1;
            for (var _i = 0, orderByList_1 = orderByList; _i < orderByList_1.length; _i++) {
                var o = orderByList_1[_i];
                var index = jsonpath.paths(this.cols, '$..[?(@.key==="' + o.name + '")]')[0][1];
                if (!this.sort[index]) {
                    this.sort[index] = {
                        order: order++,
                        direction: (o.direction == Direction.asc ? SortDirection.Up : SortDirection.Down)
                    };
                }
            }
        }
        if (this.bulkFlg) {
            var bulks = [];
            var ids = [];
            if (!this.bulkPrimaryKey || this.service.getBulkClear(this.groupName)) {
                // primaryKeyが未設定 または 検索、検索クリア、画面遷移のとき、クリアする
                this.service.clearBulkRecs(this.groupName);
            }
            else {
                // 並び替え、表示件数変更、ページングのとき、保持・復元する
                bulks = this.service.getBulkRecs(this.groupName);
                ids = this.service.getBulkIds(this.groupName);
            }
            var num = this.recs.length;
            var checked = 0;
            var checkData = [];
            for (var _a = 0, _b = this.recs; _a < _b.length; _a++) {
                var rec = _b[_a];
                var flg = false;
                if (ids.indexOf(rec[this.bulkPrimaryKey]) >= 0) {
                    flg = true;
                    checked++;
                }
                checkData.push(flg);
            }
            this.bulkChecked = checkData;
            this.setBulkHeader(num, checked);
            this.service.setBulk(this.groupName, bulks);
            this.service.setBulkClear(this.groupName, true);
        }
    };
    ListComponent.prototype.onEvent = function (e1, e2, rec) {
        var _this = this;
        if (e2 === 'row') {
            if ((e1.target.tagName === 'LABEL' && e1.target.className.match(/formInputCheckboxLabel/)) || (e1.target.tagName === 'INPUT') || !this.clickable) {
                return;
            }
            this.action.setRec(rec);
            this.action.firstAction(this.events[e2]);
        }
        else if (e2 === 'sort') {
            this.service.setBulkClear(this.groupName, false);
            var orderByList = this.onSort(rec);
            this.service.getQuery({ orderByList: orderByList }, this.groupName);
            this.action.firstAction(this.events[e2], { queryGroupName: this.groupName });
        }
        else if (e2 === 'bulk') {
            var bulks_1 = [];
            var checkData_1 = {};
            if (rec === 'header') {
                var checked_1 = e1.target.checked;
                this.bulkElement.map(function (el) {
                    el.nativeElement.checked = checked_1;
                });
                if (checked_1) {
                    bulks_1 = this.recs;
                }
                if (this.bulkPrimaryKey) {
                    for (var _i = 0, _a = this.recs; _i < _a.length; _i++) {
                        var rec_1 = _a[_i];
                        checkData_1[rec_1[this.bulkPrimaryKey]] = checked_1;
                    }
                }
            }
            else {
                var num = this.bulkElement.length;
                var checked_2 = 0;
                this.bulkElement.map(function (el, index) {
                    if (el.nativeElement.checked) {
                        bulks_1.push(_this.recs[index]);
                        checked_2++;
                    }
                    if (_this.bulkPrimaryKey) {
                        checkData_1[_this.recs[index][_this.bulkPrimaryKey]] = el.nativeElement.checked;
                    }
                });
                this.setBulkHeader(num, checked_2);
            }
            this.service.setBulk(this.groupName, this.service.mergeBulkRecs(this.groupName, bulks_1, checkData_1));
        }
        else if (e2 === 'click') {
            this.action.setRec(rec);
            this.action.firstAction(e1.event);
        }
    };
    ListComponent.prototype.setBulkHeader = function (length, checked) {
        var header = this.bulkHeaderElement.nativeElement;
        if (length == checked && length !== 0) {
            header.indeterminate = false;
            header.checked = true;
        }
        else if (length > checked && checked !== 0) {
            header.indeterminate = true;
            header.checked = false;
        }
        else {
            header.checked = false;
            header.indeterminate = false;
        }
    };
    ListComponent.prototype.onSort = function (rec) {
        var orderByList = this.service.getCurrentQuery(this.groupName).orderByList;
        var newOrderByList = [];
        var isDirectionChange = false;
        var keys = [];
        if (rec.key) {
            keys.push(rec.key);
        }
        else if (rec.items) {
            for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.key) {
                    keys.push(item.key);
                }
            }
        }
        for (var _b = 0, orderByList_2 = orderByList; _b < orderByList_2.length; _b++) {
            var o = orderByList_2[_b];
            if (keys.indexOf(o.name) >= 0) {
                isDirectionChange = true;
                if (o.direction === Direction.asc) {
                    o.direction = Direction.desc;
                    newOrderByList.push(o);
                }
            }
            else {
                newOrderByList.push(o);
            }
        }
        if (!isDirectionChange) {
            for (var _c = 0, keys_1 = keys; _c < keys_1.length; _c++) {
                var key = keys_1[_c];
                newOrderByList.push({ name: key, direction: Direction.asc });
            }
        }
        return newOrderByList;
    };
    ListComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.bulkSubsc.unsubscribe();
    };
    ListComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'list',
                    template: "<div class=\"tableWrapper\" id=\"{{ componentName }}\">\n  <table class=\"tableWrapper_table\">\n    <thead>\n    <tr data-href=\"#\">\n      <th *ngIf=\"bulkFlg\" scope=\"col\" class=\"table_select\">\n        <input type=\"checkbox\" id=\"{{ componentName + '_bulk_header' }}\" class=\"formInputCheckbox\" (change)=\"onEvent($event, 'bulk', 'header')\" #bulkHeader>\n        <label for=\"{{ componentName + '_bulk_header' }}\" class=\"formInputCheckboxLabel\">&emsp;&emsp;</label>\n        <label for=\"{{ componentName + '_bulk_header' }}\" class=\"formInputCheckboxIndeterminateLabel\"></label>\n      </th>\n      <th *ngIf=\"component.params?.dispUnit !== false\"><a class=\"-fixed\">{{ (msg | async)['ListComponent.label.unit'] }}</a></th>\n      <th *ngFor=\"let col of cols; let index = index; trackBy: trackByCol\" scope=\"col\">\n        <a [class.-fixed]=\"!sortable || col.sortable === false || col.controlType === 'img' || col.controlType === 'link'\" (click)=\"onEvent($event, 'sort', col)\">{{ col.label }}\n          <ng-template [ngIf]=\"sort[index]\"><span\n              class=\"tableWrapper_sort{{ sort[index].direction }}\"></span><span\n              class=\"tableWrapper_sortNo\">{{ sort[index].order }}</span></ng-template>\n        </a>\n      </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr *ngFor=\"let rec of recs; let index = index;\" data-href=\"#\" [class.tr_cursorDefault]=\"!clickable\" (click)=\"onEvent($event, 'row', rec)\">\n      <td *ngIf=\"bulkFlg\" class=\"table_select\">\n        <input type=\"checkbox\" name=\"{{ componentName + '_bulk' }}\" id=\"{{ componentName + '_bulk_' + index }}\" class=\"formInputCheckbox\" [checked]=\"bulkChecked[index]\" (change)=\"onEvent($event, 'bulk', index)\" #bulk>\n        <label for=\"{{ componentName + '_bulk_' + index }}\" class=\"formInputCheckboxLabel\"></label>\n      </td>\n      <td *ngIf=\"component.params?.dispUnit !== false\">\n        <ng-template [ngIf]=\"rec.unit?.owners\" [ngIfElse]=\"elseBlock\">\n          <label>{{ rec.unit?.owners[0] }}</label><label *ngIf=\"rec.unit_m?.length > 1\">[{{ rec.unit_m.length }}]</label>\n        </ng-template>\n        <ng-template #elseBlock><label>{{ (msg | async)['ListComponent.label.unitAll'] }}</label></ng-template>\n      </td>\n      <td *ngFor=\"let col of cols; trackBy: trackByCol\" [col]=\"col\" listDir>\n        <ng-template [ngIf]=\"!col.items\" [ngIfElse]=\"elseBlock\"><!--\n          --><listrowgroup [componentName]=\"parentComponentName || componentName\" [col]=\"col\" [val]=\"rec\" [msg]=\"(msg | async)\" (clickCol)=\"onEvent($event, 'click', rec)\"></listrowgroup><!--\n          --><column-copy *ngIf=\"col?.params?.copy === true\" [key]=\"'listrow'\" [col]=\"col\" [val]=\"rec[col.key]\" [msg]=\"(msg | async)\"></column-copy><!--\n        --></ng-template><!--\n        --><ng-template #elseBlock><!--\n          --><ng-template ngFor let-item [ngForOf]=\"col.items\" [ngForTrackBy]=\"trackByCol\"><!--\n            --><listrowgroup [componentName]=\"parentComponentName || componentName\" [col]=\"item\" [val]=\"rec\" [msg]=\"(msg | async)\" (clickCol)=\"onEvent($event, 'click', rec)\"></listrowgroup><!--\n            --><column-copy *ngIf=\"item?.params?.copy === true\" [key]=\"'listrow'\" [col]=\"item\" [val]=\"rec[item.key]\" [msg]=\"(msg | async)\"></column-copy><!--\n          --></ng-template><!--\n        --></ng-template>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    ListComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ListService }
    ]; };
    ListComponent.propDecorators = {
        parentComponentName: [{ type: Input }],
        bulkHeaderElement: [{ type: ViewChild, args: ['bulkHeader',] }],
        bulkElement: [{ type: ViewChildren, args: ['bulk',] }]
    };
    return ListComponent;
}(ContentBaseComponent));
export { ListComponent };
var ListRowGroupComponent = /** @class */ (function () {
    function ListRowGroupComponent() {
        this.clickCol = new EventEmitter();
    }
    ListRowGroupComponent.prototype.ngOnInit = function () {
    };
    ListRowGroupComponent.prototype.onClick = function (e) {
        this.clickCol.emit(e);
    };
    ListRowGroupComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'listrowgroup',
                    template: "<ng-container [ngSwitch]=\"col.controlType\"><!--\n    --><!-- kts --><!--\n    --><ng-container *ngSwitchCase=\"'constructionClassification'\"></ng-container><!--\n    --><column *ngSwitchCase=\"'fileInfo'\" [key]=\"'form'\" [col]=\"{key: col.key, controlType: col.controlType, readonly: true\n    , params: col.params}\" [val]=\"val\" [msg]=\"msg\"></column><!--\n    --><!-- ma31 --><!--\n    --><column-img *ngSwitchCase=\"'img'\" [col]=\"{\n            key: col.key,\n            controlType: col.controlType,\n            params: {style: {height: '12px'}, cache: col.params?.cache}\n        }\" [val]=\"val[col.key]\" [msg]=\"msg\"></column-img><!--\n    --><column-link *ngSwitchCase=\"'link'\" [col]=\"col\" [val]=\"val[col.key]\" [msg]=\"msg\"></column-link><!--\n    --><column-button *ngSwitchCase=\"'button'\" [key]=\"'listrow'\" [col]=\"col\" [msg]=\"msg\" (clickCol)=\"onClick($event)\"></column-button><!--\n    -->\n<!--  <column *ngSwitchCase=\"'fileInfo'\" [key]=\"'form'\" [col]=\"{key: col.key, controlType: col.controlType, readonly: true, params: col.params}\" [val]=\"val\" [msg]=\"msg\"></column>-->\n  <!--\n    --><ng-container *ngSwitchCase=\"'displayTarget'\"></ng-container><!--\n    --><column-formlabel *ngSwitchDefault [componentName]=\"componentName\" [col]=\"col\" [val]=\"val[col.key]\" [msg]=\"msg\" [preWrap]=\"false\"></column-formlabel><!--\n--></ng-container>"
                }] }
    ];
    /** @nocollapse */
    ListRowGroupComponent.ctorParameters = function () { return []; };
    ListRowGroupComponent.propDecorators = {
        clickCol: [{ type: Output }],
        componentName: [{ type: Input }],
        col: [{ type: Input }],
        val: [{ type: Input }],
        msg: [{ type: Input }]
    };
    return ListRowGroupComponent;
}());
export { ListRowGroupComponent };
export var SortDirection;
(function (SortDirection) {
    SortDirection.Up = 'Up';
    SortDirection.Down = 'Down';
})(SortDirection || (SortDirection = {}));
var Sort = /** @class */ (function () {
    function Sort() {
    }
    return Sort;
}());
//# sourceMappingURL=list.component.js.map